@if (this.grid && this.show) {
  <div class="pagination-container">
    <div class="pagination-info">
      <cam-text size="sm" color="secondary">{{ 'grid.pagination.showing' | translate }}</cam-text>
      <cam-text size="sm" [isBold]="true">{{ this.rangeStart }}-{{ this.rangeEnd }}</cam-text>
      <cam-text size="sm" color="secondary">{{ 'grid.pagination.of' | translate }}</cam-text>
      <cam-text size="sm" [isBold]="true">{{ this.totalRows }}</cam-text>
    </div>

    <div class="pagination-controls">
      <cam-button
        type="secondary"
        size="small"
        icon="arrow-big-left"
        [state]="this.currentPage === 1 ? 'disabled' : 'classic'"
        (action)="this.goToPrevious()"
      ></cam-button>

      @for (page of this.getListPage(); track this.track($index, page)) {
        @if (page.isEllipsis) {
          <cam-text class="pagination-ellipsis" size="sm" color="tertiary">…</cam-text>
        } @else {
          <cam-button
            size="small"
            [type]="page.number === this.currentPage ? 'primary' : 'secondary'"
            (action)="this.goToPage(page.number)"
          >
            {{ page.number }}
          </cam-button>
        }
      }

      <cam-button
        type="secondary"
        size="small"
        icon="arrow-big-right"
        [state]="this.currentPage === this.totalPages ? 'disabled' : 'classic'"
        (action)="this.goToNext()"
      ></cam-button>
    </div>
  </div>
}
